/**
 * Labelled key/value block used in the channel detail / manage sidebars.
 * Uppercase eyebrow label above arbitrary content.
 */
export function MetaBlock({ label, children }) {
	return (
		<div>
			<div className="mb-1.5 text-[11px] font-semibold uppercase tracking-[0.14em] text-muted-foreground">{label}</div>
			{children}
		</div>
	);
}
